import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

function HomeVideo() {  
 const desktopRef = useRef(null);
 const mobileRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768; // adjust as needed

    const playVideo = () => {
      const video = isMobile ? mobileRef.current : desktopRef.current;
      if (video) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((err) => {
            console.warn('Autoplay error:', err);
          });
        }
      }
    };

    if (document.readyState === 'complete') {
      setTimeout(playVideo, 100); // short delay improves iOS behavior
    } else {
      window.addEventListener('load', () => setTimeout(playVideo, 100));
    }
  }, []);
  
  return (
    <>
    <div className="herovedio">
      <Link to="/aboutchaashni#video">
      <div className="about">
        <span>The World of</span> {/* <span>MAANSI <img src='/images/Lotus-White-30.png' alt='' /> KETAN</span> */}
        <span className="logo-about"><img src='/images/white-logo.png' alt='Chaashi' /></span>
        <span className="flower-box"><img src='/images/about/flower.png' alt='Chaashi' /></span>
      </div>

     <video ref={desktopRef} autoPlay muted loop playsInline preload="auto" className="deskto-video" poster={`${process.env.REACT_APP_IMAGE_URL}/home/banner/poster.jpg`} >
      <source src={`${process.env.REACT_APP_IMAGE_URL}/home/banner/home.mp4`} type="video/mp4" />
     </video> 

    <video ref={mobileRef} autoPlay muted loop playsInline preload="auto" className="mobile-video"  poster={`${process.env.REACT_APP_IMAGE_URL}/home/banner/poster-mobile.jpg`} >
      <source src={`${process.env.REACT_APP_IMAGE_URL}/home/banner/video-Mobile.mp4`} type="video/mp4" />
    </video> 
    </Link>
    </div>
    </>
  );
}

export default HomeVideo;
